import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Location, LocationService } from 'services/location.service';

@Component({
	selector: 'ras-foreign-national-page',
	templateUrl: './foreign-national-page.component.html',
	styleUrls: ['./foreign-national-page.component.sass']
})
export class ForeignNationalPageComponent implements OnInit {

	public location: Location = null;

	constructor(private route: ActivatedRoute, private locationService: LocationService) { }

	ngOnInit() {
		this.route.paramMap.subscribe(params => {
			let location_key = params.get('location')

			this.locationService.get_all()
			.then(locations => {
				for (let location of locations) {
					if (location.key == location_key) {
						this.location = location
						break
					}
				}
				// TODO redirect on no location found
			})
		});
	}

}
